import cn from "classnames";
import { Select } from "components/shared/form";
import React, { useState } from "react";
import { addCars, getListForSelect } from "sources/books/usersGroups";

export default function MoveGroup({ group, setGroup, carId, useUniqueUsersGroups, refreshData, back }) {
    const [selectedGroup, setSelectedGroup] = useState({ id: group.id });
    const handleMove = () => {
        if (selectedGroup.id === group.id || selectedGroup.id === null) {
            return;
        }
        addCars({ groupId: selectedGroup.id, carIds: [carId], forceMoveOnConflicting: true }).then((res) => {
            if (res) {
                if (useUniqueUsersGroups) {
                    refreshData();
                } else {
                    setGroup(selectedGroup);
                }
                back();
            }
        });
    };
    return (
        <div>
            <Select
                label="Группа"
                inputProps={{ name: "groupId" }}
                onChange={({ option }) => setSelectedGroup(option)}
                value={selectedGroup?.id}
                url={getListForSelect}
                propName="name"
                menuPortalTarget={document.body}
            />
            <div className="alert alert-danger font-size-14">
                При переносе машины в другую группу, она будет удалена из всех текущих групп.
            </div>
            <div
                className={cn("btn btn-brand float-right", {
                    disabled: !selectedGroup.id || group.id === selectedGroup.id,
                })}
                onClick={handleMove}
            >
                Перенести
            </div>
        </div>
    );
}
